// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2170-28699
// Figma component name: CarOption

import { useRef } from 'react'
import { useFormikContext, Field } from 'formik'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import { formatTime } from '~/utils/format'
import Pill from '~/components/ui/Pill'
import Spinner from '~/components/ui/Spinner'

// Matches Figma Radiobutton (node 52:1061 / 52:1063)
function RadioIcon({ selected }) {
  if (selected) {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" className="shrink-0">
        <rect x="0.25" y="0.25" width="21.5" height="21.5" rx="10.75" fill="#FFCC00" />
        <rect x="0.25" y="0.25" width="21.5" height="21.5" rx="10.75" stroke="#BA8200" strokeWidth="0.5" />
        <path fillRule="evenodd" clipRule="evenodd" d="M16.1404 6.74141C16.3176 6.88535 16.4061 6.95732 16.4635 7.03588C16.6206 7.25109 16.6517 7.53347 16.5452 7.77772C16.5064 7.86689 16.4356 7.95642 16.294 8.13548L10.6357 15.2931C10.4676 15.5057 10.3836 15.6121 10.2776 15.6621C10.1843 15.7062 10.0797 15.7203 9.97813 15.7026C9.86267 15.6825 9.75339 15.6023 9.53484 15.4419L5.92882 12.7955C5.73218 12.6512 5.63385 12.579 5.57038 12.4981C5.40396 12.2859 5.36426 12.0007 5.46639 11.7512C5.50535 11.656 5.58023 11.5597 5.72998 11.3672C5.87077 11.1862 5.94116 11.0957 6.01956 11.0362C6.2248 10.8806 6.49554 10.8411 6.73664 10.9317C6.82875 10.9664 6.92204 11.033 7.10862 11.1664L9.8395 13.1178L14.7258 6.89943C14.8706 6.71509 14.943 6.62293 15.0224 6.56357C15.2401 6.40085 15.5287 6.36861 15.7769 6.47929C15.8675 6.51967 15.9585 6.59358 16.1404 6.74141Z" fill="#17181A" />
      </svg>
    )
  }
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" className="shrink-0">
      <circle cx="11" cy="11" r="10.5" stroke="#8c8c8c" strokeWidth="1" />
    </svg>
  )
}

// Person/capacity icon (Figma node 3509:30843)
function PersonIcon() {
  return (
    <svg width="12" height="13" viewBox="0 0 12.5 13.5" fill="none" aria-hidden="true" className="shrink-0">
      <path d="M6.25 8.75C4.16374 8.75 2.30845 9.77042 1.12727 11.354C0.873052 11.6948 0.745942 11.8652 0.7501 12.0955C0.753312 12.2735 0.863613 12.4979 1.00182 12.6078C1.18071 12.75 1.4286 12.75 1.9244 12.75H10.5756C11.0714 12.75 11.3193 12.75 11.4982 12.6078C11.6364 12.4979 11.7467 12.2735 11.7499 12.0955C11.7541 11.8652 11.6269 11.6948 11.3727 11.354C10.1916 9.77042 8.33626 8.75 6.25 8.75Z" stroke="#5D5D5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.25 6.75C7.88559 6.75 9.21149 5.40685 9.21149 3.75C9.21149 2.09315 7.88559 0.75 6.25 0.75C4.61441 0.75 3.28851 2.09315 3.28851 3.75C3.28851 5.40685 4.61441 6.75 6.25 6.75Z" stroke="#5D5D5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

// Warning icon shown on network error / unavailable state (Figma node 2170:28899)
function WarningIcon() {
  return (
    <svg width="13" height="12" viewBox="0 0 12.9277 11.7907" fill="none" aria-hidden="true" className="shrink-0">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.88035 0.343484C6.13419 -0.114495 6.79351 -0.114495 7.04735 0.343484L12.8432 10.8015C13.0893 11.2458 12.7682 11.7907 12.2602 11.7907H0.667464C0.159503 11.7907 -0.161636 11.2458 0.0844565 10.8015L5.88035 0.343484ZM6.13035 5.6804C5.94656 5.68057 5.79759 5.82962 5.79735 6.01341V9.6804C5.79741 9.86433 5.94645 10.0132 6.13035 10.0134H6.79735C6.98127 10.0133 7.13029 9.86435 7.13035 9.6804V6.01341C7.13011 5.82961 6.98117 5.68055 6.79735 5.6804H6.13035ZM6.46434 3.2136C6.09623 3.2136 5.79748 3.51251 5.79735 3.88059C5.79752 4.24863 6.09626 4.54661 6.46434 4.54661C6.83215 4.54629 7.13018 4.24844 7.13035 3.88059C7.13022 3.51271 6.83218 3.21392 6.46434 3.2136Z" fill="#17181A" />
    </svg>
  )
}



export default function CarRadioField({ field, form: { setFieldValue }, title, info, capacity, availability, price, originalPrice, reducedPrice, labelRef, disabledDueToEdit, hideDisabledPill, ...props }) {
  const { t } = useTranslation()
  const { values } = useFormikContext()

  let isChecked = field.checked
  if (values.autoValues.serviceType) {
    isChecked = values.autoValues.serviceType === field.value
  }

  const isDisabled = props.disabled

  // In edit mode, don't show delayed pill if time hasn't changed
  const isEditModeWithUnchangedTime = values.bookingId &&
    !values.editableFields?.includes('pickUpTimeStamp')

  const clickRef = useRef()

  const onKeyDown = e => {
    if (e.keyCode === 32) e.preventDefault()
  }

  const onKeyUp = e => {
    if (e.keyCode === 32) {
      e.preventDefault()
      setFieldValue(field.name, field.value)
      if (props.onClick) props.onClick()
    }
  }

  const wrapperClick = () => {
    (labelRef || clickRef)?.current?.click()
  }

  const showPriceSpinner = values.priceIsLoading

  return (
    <div
      onClick={wrapperClick}
      className={classnames(
        'flex items-center gap-3 py-3 w-full cursor-pointer',
        isDisabled && 'pointer-events-none',
      )}
    >
      {/* Car image */}
      <img
        src={`/app/themes/${CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm'}/static/img/car-icons/${field.value}.png`}
        alt=""
        className={classnames('w-11 shrink-0 object-contain', isDisabled && 'opacity-[0.38]')}
      />

      {/* Info column */}
      <div className="flex flex-1 flex-col min-w-0">

        {/* Title row: name · dot · person + capacity */}
        <div className={classnames('flex items-center gap-2', isDisabled && 'opacity-[0.38]')}>
          <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface whitespace-nowrap">
            {title}
          </span>
          {capacity && (
            <>
              <div className="w-1 h-1 rounded-full bg-on-surface-variant shrink-0" aria-hidden="true" />
              <div className="flex items-center gap-0.5">
                <PersonIcon />
                <span className="text-[15px] leading-5 text-on-surface-variant">{capacity}</span>
              </div>
            </>
          )}
        </div>

        {/* Subtitle */}
        {info && (
          <span className={classnames('text-[15px] leading-5 text-on-surface-variant', isDisabled && 'opacity-[0.38]')}>{info}</span>
        )}

        {/* Pills */}
        {(availability?.availableAt === 'AS_REQUESTED' && availability?.expectedWaitTime) ||
         (availability?.availableAt === 'DELAYED' && !isDisabled && !isEditModeWithUnchangedTime) ||
         (isDisabled && !hideDisabledPill) ||
         reducedPrice ? (
          <div className="flex gap-1 flex-wrap mt-1">
            {availability?.availableAt === 'AS_REQUESTED' && availability?.expectedWaitTime && (
              <Pill text={t('approx-min', { minutes: availability.expectedWaitTime })} />
            )}
            {availability?.availableAt === 'DELAYED' && !isDisabled && !isEditModeWithUnchangedTime && (
              <Pill text={`Endast förbokning ${formatTime(new Date(availability.pickupTime))}`} type="important" />
            )}
            {isDisabled && !hideDisabledPill && (
              <Pill text={disabledDueToEdit ? 'Kan inte ändras vid redigering' : 'Ej tillgänglig'} />
            )}
            {reducedPrice && (
              <Pill text={reducedPrice} type="important" />
            )}
          </div>
        ) : null}
      </div>

      {/* Right: price + warning + radio */}
      <div className="flex items-center gap-2 shrink-0">
        {showPriceSpinner ? (
          <Spinner size={16} className="shrink-0" />
        ) : price ? (
          <div className={classnames('flex flex-col items-end', isDisabled && 'opacity-[0.38]')}>
            <span className="text-[17px] font-semibold uppercase tracking-[0.68px] leading-[22px] text-on-surface whitespace-nowrap">
              {price}
            </span>
            {originalPrice && (
              <s className="text-[15px] leading-5 text-on-surface-variant">{originalPrice}</s>
            )}
          </div>
        ) : null}

        {isDisabled && <WarningIcon />}

        <label
          ref={labelRef || clickRef}
          tabIndex="0"
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          className={classnames('cursor-pointer', isDisabled && 'opacity-[0.38]')}
        >
          <RadioIcon selected={isChecked} />
          <Field
            type="radio"
            as="input"
            className="sr-only"
            name={field.name}
            onChange={field.onChange}
            onBlur={field.onBlur}
            {...props}
          />
        </label>
      </div>
    </div>
  )
}
